/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Artifacts_Trash_DescriptionInputs */



/**
* | output |
* | --- |
* | "Deleted apps stay here for {days} days and can be restored. Their share links and custom domains stay off." |
*
* @param {Artifacts_Trash_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_trash_description = /** @type {((inputs: Artifacts_Trash_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Trash_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gelöschte Apps bleiben ${i?.days} Tage hier und lassen sich wiederherstellen. Ihre Freigabelinks und eigenen Domains bleiben aus.`)
	return /** @type {LocalizedString} */ (`Deleted apps stay here for ${i?.days} days and can be restored. Their share links and custom domains stay off.`)
});